module.exports = __webpack_public_path__ + "img/COM-B-2-III.99238b40.png";